/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  AvailableLanguagesField,
  AvailableSoftwaresField,
  MailAddressField,
  NameField,
  PortfolioField,
  QuestionField,
  ReasonField,
  ResumeField,
  SelfPrField,
  SkillSheetField,
  SocialNetworkUrlsField,
  TelField,
  RequestJobCategoryField,
} from '~/form/components/organisms'
import validationRulesComposer from '~/form/libs/validationRulesComposer'
import type { Config } from '~/form/types'

const configs: Config[] = [
  {
    name: '氏名',
    component: NameField,
    props: {
      required: true,
    },
  },
  {
    name: 'メールアドレス',
    component: MailAddressField,
    props: {
      required: true,
    },
  },
  {
    name: '電話番号',
    component: TelField,
    props: {},
  },
  {
    name: '掲載希望職種',
    component: RequestJobCategoryField,
    props: {
      required: true,
      helperText: '具体的な職種を記入してください。',
    },
  },
  {
    name: '掲載してほしい理由',
    component: ReasonField,
    props: {
      required: true,
      label: '掲載してほしい理由',
      placeholder:
        'この企業・組織に募集を再開してほしい理由と魅力を感じた点などを記入してください',
    },
  },
]

export default configs

export const validators = validationRulesComposer(configs)
